<template>
  <div class="row mb-3 crm-kpis-row">
    <div class="col-md-3 mb-2 d-flex" v-for="kpi in items" :key="kpi.key">
      <div
        class="card crm-kpi w-100"
        :class="{ active: activeKey === kpi.key }"
        @click="$emit('filter', kpi.key)"
      >
        <div class="card-body py-3 crm-kpi-body">
          <p class="crm-kpi-label text-uppercase mb-1">
            {{ kpi.label }}
          </p>
          <h3 class="mb-0 crm-kpi-value">{{ kpi.value }}</h3>
          <small class="crm-kpi-sub">{{ kpi.sub || '\u00a0' }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CrmKpis',
  props: {
    items: { type: Array, default: () => [] },
    activeKey: { type: String, default: '' }
  }
}
</script>

<style scoped>
.crm-kpis-row {
  align-items: stretch;
}
.crm-kpi {
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: border-color 0.15s ease;
  min-height: 110px;
  display: flex;
  flex-direction: column;
}
.crm-kpi-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.crm-kpi-label {
  font-size: 10px;
  letter-spacing: 0.05em;
  color: rgba(255, 255, 255, 0.65);
  min-height: 1.2em;
  margin-bottom: 0.35rem !important;
}
.crm-kpi-value {
  line-height: 1.2;
  min-height: 1.4em;
}
.crm-kpi-sub {
  display: block;
  margin-top: auto;
  min-height: 1.25em;
  color: rgba(255, 255, 255, 0.55);
}
.crm-kpi:hover,
.crm-kpi.active {
  border-color: #588bbd;
}
.w-100 {
  width: 100%;
}
</style>
